import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/scroll-arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-d1e6cf30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { style: {"width":"100%","height":"100%"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  style: {"width":"100%","height":"100%"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "scroller-image",
  src: _imports_0,
  loading: "lazy",
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { inject, reactive } from 'vue'

import VueScrollTo from 'vue-scrollto'


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const scrollTo = VueScrollTo.scrollTo

const data = reactive({
  isMobile: inject('isMobile'),
  isTablet: inject('isTablet'),
  showScroller: false
})

function checkPosition(event) {
  const windowY = event.target.scrollingElement.scrollTop
  if (windowY < 200) {
    data.showScroller = false
  } else {
    data.showScroller = true
  }
  data.scrollPos = windowY
}
function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

window.addEventListener('scroll', (event) => { checkPosition(event) })

return (_ctx: any,_cache: any) => {
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageContentMobile = _resolveComponent("PageContentMobile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!data.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_PageContent)
          ]))
        : _createCommentVNode("", true),
      (data.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_PageContentMobile)
          ]))
        : _createCommentVNode("", true),
      (data.showScroller)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["scroller", {mobile: data.isMobile, tablet: data.isTablet}]),
            onClickPassive: _cache[0] || (_cache[0] = 
          () => {
            _unref(scrollTo)('#navbar', 2400, { offset: -50 })
            _ctx.isMobileNavOpen = false
        })
          }, _hoisted_6, 34))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})